import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvironmentService } from "./environment.service";
import { ILeaderboardEntry, ISkunificationStatEntry } from "../models/skunification-dashboard/leaderboard-entry-model";

@Injectable({
  providedIn: 'root'
})

export class LeaderboardService {
  fullPath: string;
  constructor(private httpClient: HttpClient, public envService: EnvironmentService) {
    this.fullPath = `${envService.settings.apiUrl}/Skunity`;
  }

  getLeaderboard(): Observable<ILeaderboardEntry[]> {
    return this.httpClient.get<ILeaderboardEntry[]>(`${this.fullPath}/leaderboard`);
  }

  getStats(): Observable<ISkunificationStatEntry[]> {
    return this.httpClient.get<ISkunificationStatEntry[]>(`${this.fullPath}/stats`);
  }
}
